/* rc-911-remembrance.js — 9/11 Remembrance 2026 hero behaviour.
 *
 * Consumes window.RC911 (assets/rc-911-clock.js): the clock decides the mode
 * and date; this file renders the day, runs the one-time entrance + slow
 * settle, keeps the header state (over / scrolled) current, and drives the
 * film on the video day. Everything is scoped to the section element and torn
 * down on shopify:section:unload. Loaded with defer from the section.
 */
(function (win, doc) {
  'use strict';
  if (!win.RC911 || win.RC911.unsupported) return;

  var controllers = {};
  var reduceMq = win.matchMedia ? win.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function q(root, sel) { return root.querySelector(sel); }
  function fmtTime(s) {
    s = Math.max(0, Math.floor(s || 0));
    return Math.floor(s / 60) + ':' + (s % 60 < 10 ? '0' : '') + (s % 60);
  }
  function saveData() {
    try { return !!(navigator.connection && navigator.connection.saveData); } catch (e) { return false; }
  }

  function create(root) {
    var id = root.getAttribute('data-section-id');
    if (controllers[id]) controllers[id].destroy();

    var data;
    try { data = JSON.parse(q(root, '[data-rc911-days]').textContent); } catch (e) { data = { days: {}, context: '', showContext: true }; }
    var motionEnabled = root.getAttribute('data-motion') === 'true';
    var el = {
      stage: q(root, '[data-rc911-stage]'),
      text: q(root, '[data-rc911-text]'),
      film: q(root, '[data-rc911-film]'),
      headline: q(root, '[data-rc911-headline]'),
      body: q(root, '[data-rc911-body]'),
      close: q(root, '[data-rc911-close]'),
      src: q(root, '[data-rc911-src]'),
      pause: q(root, '[data-rc911-pause]'),
      video: q(root, '[data-rc911-video]'),
      bigplay: q(root, '[data-rc911-bigplay]'),
      error: q(root, '[data-rc911-error]'),
      retry: q(root, '[data-rc911-retry]'),
      layer: q(root, '[data-rc911-layer]'),
      sound: q(root, '[data-rc911-sound]'),
      play: q(root, '[data-rc911-play]'),
      time: q(root, '[data-rc911-time]'),
      seek: q(root, '[data-rc911-seek]'),
      duration: q(root, '[data-rc911-duration]'),
      mute: q(root, '[data-rc911-mute]'),
      replay: q(root, '[data-rc911-replay]'),
      transcriptToggle: q(root, '[data-rc911-transcript-toggle]'),
      transcript: q(root, '[data-rc911-transcript]')
    };
    var html = doc.documentElement;
    var cleanups = [];
    function on(target, type, fn, opts) { target.addEventListener(type, fn, opts); cleanups.push(function () { target.removeEventListener(type, fn, opts); }); }

    /* ---------------- header stack + over/scrolled state ---------------- */
    var stack = 85;
    function measureStack() {
      var bar = doc.querySelector('.salba-section-dealer-bar');
      var hdr = doc.querySelector('.section-header .header-wrapper') || doc.querySelector('.section-header');
      var h = 0;
      if (bar) h += bar.getBoundingClientRect().height;
      if (hdr) h += hdr.getBoundingClientRect().height;
      if (h > 0 && Math.abs(h - stack) >= 0.5) {
        stack = h;
        html.style.setProperty('--rc911-stack', Math.round(h) + 'px');
      } else if (h > 0 && !html.style.getPropertyValue('--rc911-stack')) {
        html.style.setProperty('--rc911-stack', Math.round(h) + 'px');
      }
    }
    var ticking = false;
    function updateOver() {
      ticking = false;
      var st = win.RC911.state();
      if (st.mode === 'off') { html.removeAttribute('data-rc911-over'); html.removeAttribute('data-rc911-scrolled'); return; }
      var r = el.stage.getBoundingClientRect();
      var hdr = doc.querySelector('.section-header .header-wrapper') || doc.querySelector('.section-header');
      var hdrBottom = hdr ? hdr.getBoundingClientRect().bottom : stack;
      var over = r.bottom > hdrBottom + 1 && r.top < hdrBottom;
      if (over) html.setAttribute('data-rc911-over', '1'); else html.removeAttribute('data-rc911-over');
      if (win.scrollY > 2) html.setAttribute('data-rc911-scrolled', '1'); else html.removeAttribute('data-rc911-scrolled');
    }
    function requestOver() { if (!ticking) { ticking = true; win.requestAnimationFrame(updateOver); } }
    on(win, 'scroll', requestOver, { passive: true });
    on(win, 'resize', function () { measureStack(); requestOver(); });
    on(win, 'orientationchange', function () { setTimeout(function () { measureStack(); requestOver(); }, 300); });
    var ro = null;
    if (win.ResizeObserver) {
      ro = new ResizeObserver(function () { measureStack(); requestOver(); });
      var bar = doc.querySelector('.salba-section-dealer-bar'); if (bar) ro.observe(bar);
      var hdr = doc.querySelector('.section-header'); if (hdr) ro.observe(hdr);
      cleanups.push(function () { ro.disconnect(); });
    }
    var io = null;
    if (win.IntersectionObserver) {
      io = new IntersectionObserver(function (entries) {
        requestOver();
        for (var i = 0; i < entries.length; i++) heroVisible = entries[i].isIntersecting;
        onHeroVisibility();
      }, { threshold: [0, 0.1] });
      io.observe(el.stage);
      cleanups.push(function () { io.disconnect(); });
    }
    var heroVisible = true;

    /* ---------------- suppressed promo sections: keep their videos quiet ---- */
    var quieted = [];
    function quietSuppressed() {
      var nodes = doc.querySelectorAll('.shopify-section');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n === root.closest('.shopify-section')) continue;
        if (getComputedStyle(n).display !== 'none') continue;
        var vids = n.querySelectorAll('video');
        for (var j = 0; j < vids.length; j++) {
          var v = vids[j];
          if (v.__rc911quiet) continue;
          v.__rc911quiet = { preload: v.getAttribute('preload'), autoplay: v.hasAttribute('autoplay') };
          try { v.pause(); } catch (e) {}
          v.setAttribute('preload', 'none');
          quieted.push(v);
        }
      }
    }
    function restoreSuppressed() {
      for (var i = 0; i < quieted.length; i++) {
        var v = quieted[i], s = v.__rc911quiet;
        if (!s) continue;
        if (s.preload == null) v.removeAttribute('preload'); else v.setAttribute('preload', s.preload);
        if (s.autoplay) { try { v.load(); var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
        delete v.__rc911quiet;
      }
      quieted = [];
    }

    /* ---------------- motion ----------------
       The entrance and the slow settle are plain CSS animations that start the
       moment the text elements first paint (see .rc911[data-motion="true"] in
       rc-911-remembrance.css), so the server-rendered day never flashes visible
       and then fades in. JS only (a) restarts them for a NEW date, (b) pauses
       the settle, (c) honours a session-long pause with a static hero. */
    var paused = false;
    try { paused = win.sessionStorage.getItem('rc911:paused') === '1'; } catch (e) {}
    var ANIMATED = ['[data-rc911-mark]', '[data-rc911-ctx]', '[data-rc911-headline]', '[data-rc911-body]', '[data-rc911-close]', '[data-rc911-src]', '[data-rc911-zoom]'];
    function reduced() { return !!(reduceMq && reduceMq.matches); }
    function motionOn() { return motionEnabled && !reduced(); }
    function applyReduced() {
      root.classList.toggle('is-reduced', reduced());
      if (reduced() && el.pause) el.pause.hidden = true;
    }
    if (reduceMq) {
      var onMq = function () { applyReduced(); };
      if (reduceMq.addEventListener) { reduceMq.addEventListener('change', onMq); cleanups.push(function () { reduceMq.removeEventListener('change', onMq); }); }
      else if (reduceMq.addListener) { reduceMq.addListener(onMq); cleanups.push(function () { reduceMq.removeListener(onMq); }); }
    }
    var motionTimers = [];
    function clearMotionTimers() { for (var i = 0; i < motionTimers.length; i++) clearTimeout(motionTimers[i]); motionTimers = []; }
    function setPauseLabel() {
      if (!el.pause) return;
      el.pause.textContent = root.getAttribute(paused ? 'data-resume-label' : 'data-pause-label');
      el.pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
    }
    function zoomSeconds() {
      return parseFloat(getComputedStyle(root.closest('.shopify-section') || root).getPropertyValue('--rc911-zoom-duration')) || 11;
    }
    /* show the control while the settle runs, then tuck it away */
    function armPauseControl() {
      clearMotionTimers();
      if (!el.pause) return;
      if (!motionOn()) { el.pause.hidden = true; return; }
      el.pause.hidden = false;
      setPauseLabel();
      if (!paused) motionTimers.push(setTimeout(function () { if (!paused) el.pause.hidden = true; }, zoomSeconds() * 1000 + 200));
    }
    /* restart the CSS animations (used only when the date changes in an open tab) */
    function restartMotion() {
      root.classList.remove('is-entered');
      for (var i = 0; i < ANIMATED.length; i++) {
        var n = root.querySelector(ANIMATED[i]);
        if (n) n.style.animation = 'none';
      }
      void root.offsetWidth;
      for (var j = 0; j < ANIMATED.length; j++) {
        var m = root.querySelector(ANIMATED[j]);
        if (m) m.style.animation = '';
      }
    }
    /* the first CSS entrance is still running this long after navigation start */
    function firstEntranceRunning() {
      var ms = parseFloat(getComputedStyle(root.closest('.shopify-section') || root).getPropertyValue('--rc911-entrance')) || 1100;
      return (win.performance && win.performance.now ? win.performance.now() : 1e9) < ms + 1200;
    }
    function entrance(fresh) {
      if (paused) { root.classList.add('is-static'); if (el.pause && motionOn()) { el.pause.hidden = false; setPauseLabel(); } return; }
      root.classList.remove('is-static');
      /* a new date restarts the motion — unless the very first entrance is still
         playing (cached page or preview whose date differs from the server's):
         then the text is swapped inside the running entrance, no second fade */
      if (fresh && !(el.text && !el.text.hidden && firstEntranceRunning())) restartMotion();
      armPauseControl();
    }
    if (el.pause) {
      on(el.pause, 'click', function () {
        paused = !paused;
        try { win.sessionStorage.setItem('rc911:paused', paused ? '1' : '0'); } catch (e) {}
        if (paused) {
          clearMotionTimers();
          root.classList.add('is-paused'); /* freezes the slow settle; the entrance is left to finish */
        } else {
          root.classList.remove('is-paused');
          if (root.classList.contains('is-static')) {
            /* resumed from a session-long pause: play only the settle, not a second entrance */
            root.classList.remove('is-static');
            root.classList.add('is-entered');
            var z = root.querySelector('[data-rc911-zoom]');
            if (z) { z.style.animation = 'none'; void root.offsetWidth; z.style.animation = ''; }
          }
          armPauseControl();
        }
        setPauseLabel();
      });
    }

    /* ---------------- text day rendering ---------------- */
    var shownDate = root.getAttribute('data-server-date');
    var shownMode = root.getAttribute('data-server-mode');
    function renderText(date, fresh) {
      var d = data.days[date];
      if (!d) return false;
      el.headline.textContent = d.headline || '';
      el.body.textContent = d.body || '';
      el.close.textContent = d.closing || '';
      if (d.sourceUrl && d.sourceLabel) { el.src.textContent = d.sourceLabel; el.src.href = d.sourceUrl; el.src.hidden = false; }
      else { el.src.hidden = true; el.src.textContent = ''; el.src.href = '#'; }
      el.text.hidden = false;
      el.film.hidden = true;
      entrance(fresh);
      return true;
    }

    /* ---------------- film ---------------- */
    var film = {
      ready: false, userPaused: false, hadSound: false, autoplayBlocked: false, idleTimer: null, everPlayed: false
    };
    var V = el.video;
    function pickSrc() {
      var hd = root.getAttribute('data-video-hd') || '', sd = root.getAttribute('data-video-sd') || hd;
      return (win.innerWidth >= 750 ? hd : sd) || hd || sd;
    }
    function showError(show) { if (el.error) el.error.hidden = !show; }
    function showBigPlay(show) { if (el.bigplay) el.bigplay.hidden = !show; }
    /* The poster (final card) is shown only when the film cannot play by itself;
       as a poster attribute it would flash before the first frame decodes. */
    function showPoster(show) {
      var src = root.getAttribute('data-poster');
      if (show && src) { if (V.getAttribute('poster') !== src) V.setAttribute('poster', src); }
      else if (V.hasAttribute('poster')) V.removeAttribute('poster');
    }
    function setIdle(idle) { el.film.classList.toggle('is-idle', !!idle); }
    function bumpIdle() {
      setIdle(false);
      if (film.idleTimer) clearTimeout(film.idleTimer);
      if (!V.paused && !V.ended) film.idleTimer = setTimeout(function () { if (!V.paused && !V.ended) setIdle(true); }, 3000);
    }
    function attachSource() {
      var src = pickSrc();
      if (!src) { showError(true); return false; }
      if (V.getAttribute('src') !== src) {
        V.setAttribute('preload', 'auto');
        V.src = src;
        try { V.load(); } catch (e) {}
      }
      film.ready = true;
      return true;
    }
    function tryAutoplay() {
      if (!attachSource()) return;
      if (reduced() || saveData()) { showPoster(true); showBigPlay(true); setIdle(false); return; }
      V.muted = true;
      el.mute.setAttribute('aria-pressed', 'true'); el.mute.setAttribute('aria-label', 'Unmute');
      el.film.classList.remove('has-sound');
      try { V.currentTime = 0; } catch (e) {}
      var p;
      try { p = V.play(); } catch (e) { p = Promise.reject(e); }
      if (p && p.then) {
        p.then(function () { film.autoplayBlocked = false; showBigPlay(false); bumpIdle(); })
         .catch(function () { film.autoplayBlocked = true; showPoster(true); showBigPlay(true); setIdle(false); });
      }
    }
    function playWithSound() {
      if (!attachSource()) return;
      showError(false);
      V.muted = false;
      el.mute.setAttribute('aria-pressed', 'false'); el.mute.setAttribute('aria-label', 'Mute');
      el.film.classList.add('has-sound');
      film.hadSound = true;
      film.userPaused = false;
      try { V.currentTime = 0; } catch (e) {}
      var p = V.play();
      if (p && p.then) p.then(function () { showBigPlay(false); if (el.sound) el.sound.hidden = true; bumpIdle(); })
                        .catch(function () { showPoster(true); showBigPlay(true); setIdle(false); });
    }
    function togglePlay() {
      if (!attachSource()) return;
      if (V.paused || V.ended) {
        film.userPaused = false;
        if (V.ended) { try { V.currentTime = 0; } catch (e) {} }
        var p = V.play(); if (p && p.catch) p.catch(function () { showBigPlay(true); });
      } else { film.userPaused = true; V.pause(); }
    }
    function unloadVideo() {
      if (film.idleTimer) clearTimeout(film.idleTimer);
      try { V.pause(); } catch (e) {}
      if (V.getAttribute('src')) { V.removeAttribute('src'); try { V.load(); } catch (e) {} }
      V.setAttribute('preload', 'none');
      showPoster(false);
      film.ready = false; film.userPaused = false; film.hadSound = false; film.everPlayed = false;
      el.film.classList.remove('is-playing', 'has-sound', 'is-idle');
      if (el.sound) el.sound.hidden = false;
      showBigPlay(false); showError(false);
      if (el.transcript && !el.transcript.hidden) toggleTranscript(false);
    }
    function onHeroVisibility() {
      if (shownMode !== 'video' || !film.ready) return;
      if (!heroVisible || doc.hidden) {
        if (!V.paused && !V.ended) { film.autoPausedMuted = V.muted; film.autoPaused = true; V.pause(); }
      } else if (film.autoPaused && !film.userPaused) {
        film.autoPaused = false;
        if (film.autoPausedMuted && V.muted) { var p = V.play(); if (p && p.catch) p.catch(function () {}); }
        else setIdle(false); /* had sound: offer resume, never surprise with audio */
      }
    }
    on(doc, 'visibilitychange', onHeroVisibility);

    function toggleTranscript(open) {
      if (!el.transcript || !el.transcriptToggle) return;
      var isOpen = open != null ? open : el.transcript.hidden;
      el.transcript.hidden = !isOpen;
      el.transcriptToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      el.transcriptToggle.textContent = root.getAttribute(isOpen ? 'data-transcript-hide-label' : 'data-transcript-label');
      if (isOpen) { try { el.transcript.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' }); } catch (e) {} }
    }

    if (V) {
      on(V, 'loadedmetadata', function () { if (el.duration) el.duration.textContent = fmtTime(V.duration); });
      on(V, 'timeupdate', function () {
        if (!V.duration) return;
        var pct = V.currentTime / V.duration;
        if (el.seek) { el.seek.value = Math.round(pct * 1000); el.seek.style.setProperty('--rc911-seek', (pct * 100) + '%'); el.seek.setAttribute('aria-valuetext', fmtTime(V.currentTime)); }
        if (el.time) el.time.textContent = fmtTime(V.currentTime);
      });
      on(V, 'play', function () { film.everPlayed = true; el.film.classList.add('is-playing'); el.play.setAttribute('aria-label', 'Pause'); showBigPlay(false); showError(false); bumpIdle(); });
      on(V, 'playing', function () { showPoster(false); });
      on(V, 'pause', function () { el.film.classList.remove('is-playing'); el.play.setAttribute('aria-label', 'Play'); setIdle(false); });
      on(V, 'ended', function () { el.film.classList.remove('is-playing'); el.play.setAttribute('aria-label', 'Replay'); setIdle(false); /* hold the final card; no loop */ });
      on(V, 'volumechange', function () {
        el.film.classList.toggle('has-sound', !V.muted);
        el.mute.setAttribute('aria-pressed', V.muted ? 'true' : 'false');
        el.mute.setAttribute('aria-label', V.muted ? 'Unmute' : 'Mute');
        if (!V.muted && el.sound) el.sound.hidden = true;
      });
      on(V, 'error', function () { if (V.getAttribute('src')) { showPoster(true); showError(true); showBigPlay(false); el.film.classList.remove('is-playing'); setIdle(false); } });
      on(V, 'stalled', function () { setIdle(false); });
      on(el.play, 'click', togglePlay);
      on(el.bigplay, 'click', function () { playWithSound(); });
      on(el.sound, 'click', function () { playWithSound(); });
      on(el.mute, 'click', function () { if (!attachSource()) return; V.muted = !V.muted; });
      on(el.replay, 'click', function () { if (!attachSource()) return; film.userPaused = false; try { V.currentTime = 0; } catch (e) {} var p = V.play(); if (p && p.catch) p.catch(function () { showBigPlay(true); }); });
      on(el.retry, 'click', function () { showError(false); showPoster(false); V.removeAttribute('src'); try { V.load(); } catch (e) {} film.ready = false; tryAutoplay(); });
      on(el.seek, 'input', function () { if (!attachSource() || !V.duration) return; V.currentTime = (el.seek.value / 1000) * V.duration; bumpIdle(); });
      on(el.transcriptToggle, 'click', function () { toggleTranscript(); });
      on(el.film, 'mousemove', bumpIdle, { passive: true });
      on(el.film, 'touchstart', bumpIdle, { passive: true });
      on(el.film, 'focusin', bumpIdle);
      on(el.film, 'keydown', function (e) {
        if (e.target && (e.target.tagName === 'INPUT')) return;
        if (e.key === ' ' || e.key === 'k') { e.preventDefault(); togglePlay(); }
        else if (e.key === 'm') { V.muted = !V.muted; }
        bumpIdle();
      });
      on(V, 'click', function () { togglePlay(); bumpIdle(); });
    }

    function renderVideo(fresh) {
      el.text.hidden = true;
      el.film.hidden = false;
      clearMotionTimers();
      if (el.pause) el.pause.hidden = true;
      if (fresh || !film.ready) tryAutoplay();
    }

    /* ---------------- state → render ---------------- */
    var wasOff = false;
    function render(st) {
      measureStack();
      if (st.mode === 'off') {
        if (!wasOff) { unloadVideo(); restoreSuppressed(); clearMotionTimers(); }
        wasOff = true; shownMode = 'off';
        html.removeAttribute('data-rc911-over'); html.removeAttribute('data-rc911-scrolled');
        if (win.RC911.settle) win.RC911.settle();
        return;
      }
      wasOff = false;
      quietSuppressed();
      var fresh = st.date !== shownDate || st.mode !== shownMode;
      if (st.mode === 'video') {
        unloadIfNeeded('video');
        renderVideo(fresh);
      } else {
        if (shownMode === 'video') unloadVideo();
        if (!renderText(st.date, fresh)) { /* no copy for this date: leave a plain black hero rather than stale text */ el.headline.textContent = ''; el.body.textContent = ''; el.close.textContent = ''; el.src.hidden = true; el.text.hidden = false; el.film.hidden = true; }
      }
      shownDate = st.date; shownMode = st.mode;
      if (win.RC911.settle) win.RC911.settle();
      requestOver();
    }
    function unloadIfNeeded(mode) { if (mode === 'video' && shownMode !== 'video') { /* entering film day */ } }

    applyReduced();
    measureStack();
    var unsubscribe = win.RC911.subscribe(render);
    cleanups.push(unsubscribe);
    /* server-rendered text day: the CSS entrance is already running from first paint; arm the control only */
    if (shownMode === 'text' && win.RC911.state().mode === 'text' && win.RC911.state().date === shownDate) entrance(false);
    requestOver();

    /* editor: expose preview hook */
    root.__rc911 = { preview: function (spec) { return win.RC911.preview(spec); } };

    var ctrl = {
      destroy: function () {
        clearMotionTimers();
        unloadVideo();
        restoreSuppressed();
        root.classList.remove('is-paused', 'is-static', 'is-entered');
        for (var i = cleanups.length - 1; i >= 0; i--) { try { cleanups[i](); } catch (e) {} }
        cleanups = [];
        html.removeAttribute('data-rc911-over'); html.removeAttribute('data-rc911-scrolled');
        delete controllers[id];
      }
    };
    controllers[id] = ctrl;
    return ctrl;
  }

  function boot(scope) {
    var roots = (scope || doc).querySelectorAll('[data-rc911-section]');
    for (var i = 0; i < roots.length; i++) create(roots[i]);
  }
  boot();
  doc.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  doc.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-rc911-section]');
    if (r) { var id = r.getAttribute('data-section-id'); if (controllers[id]) controllers[id].destroy(); }
  });
})(window, document);
